import React, { useState } from "react"
import imageCompression from "browser-image-compression"
// import { storage } from "./firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"
import axios from "axios"
import { db, storage } from "../../../../firebase-config"

function DealerMobileScreen() {
  const [selectedOption, setSelectedOption] = useState("")
  const [selectedService, setSelectedService] = useState("")
  const [otherText, setOtherText] = useState("")
  const [otherSelectedService, setOtherSelectedService] = useState("")
  const [loading, setLoading] = useState(false)
  const [serviceAddons, setServiceAddons] = useState([])
  const [serviceAddonOther, setServiceAddonOther] = useState("")
  const [formData, setFormData] = useState({
    dealer: "JIM PATTISON",
    dealerOther: "",
    service: "",
    serviceAddon: "",
    make: "",
    model: "",
    year: "",
    vin: "",
    submittedBy: "",
    submittedOther: "",
    vinImage: null,
    otherImages: [],
    serviceStatus: "",
    serviceDuration: "",
  })

  const [preview, setPreview] = useState({
    vin: null,
    others: [],
  })
  const dealer = [
    "JIM PATTISON",
    "ALPHA",
    "NR",
    "KARSHELL",
    "KNN",
    "Toyota Group",
    "GLOBAL",
    "A&C Automotive",
    "SILVER FOX",
    "Dash Auto",
    "Dena Auto",
    "Lion Auto",
  ]

  const submittedPersons = [
    "Sukh",
    "Prabhjot",
    "Jaskaran",
    "Jass",
    "Ravi",
    "Yuvraj",
    "Karan",
    "Ekam",
  ]

  const serviceList = [
    "Dealers Package",
    "Decals Remove",
    "Express Package",
    "Other",
  ]

  const addonList = [
    "Machine Wax",
    "Pet Hair",
    "Mold",
    "Odor Removal",
    "Decal Removal",
    "Engine Cleaning",
  ]

  const serviceStatus = ["Completed", "Pending"]

  // const compressTo60KB = async (file) => {
  //   const MAX_SIZE_KB = 60
  //   let quality = 0.8
  //   let compressed = file

  //   while (true) {
  //     compressed = await imageCompression(file, {
  //       maxWidthOrHeight: 800, // better compression
  //       useWebWorker: true,
  //       initialQuality: quality,
  //     })

  //     const sizeKB = compressed.size / 1024

  //     console.log("Compressed:", sizeKB.toFixed(2), "KB")

  //     if (sizeKB <= MAX_SIZE_KB || quality <= 0.2) break

  //     quality -= 0.1
  //   }

  //   return compressed
  // }
  const compressTo60KB = async (file) => {
    const MAX_SIZE_KB = 60

    let quality = 0.8
    let maxWidth = 1024

    let compressed = file

    while (true) {
      compressed = await imageCompression(file, {
        maxWidthOrHeight: maxWidth,
        useWebWorker: true,
        initialQuality: quality,
      })

      const sizeKB = compressed.size / 1024

      console.log(
        `Size: ${sizeKB.toFixed(2)}KB | Quality: ${quality} | Width: ${maxWidth}`,
      )

      // ✅ Success condition
      if (sizeKB <= MAX_SIZE_KB) break

      // 🔽 First reduce quality
      if (quality > 0.3) {
        quality -= 0.1
      }
      // 🔽 Then reduce resolution
      else if (maxWidth > 820) {
        maxWidth -= 150
      }
      // 🛑 Stop if too low (avoid destroying image)
      else {
        console.warn("Could not reach 60KB without heavy loss")
        break
      }
    }

    return compressed
  }
  const handleVinImage = async (e) => {
    const file = e.target.files[0]
    if (!file) return

    try {
      const compressed = await compressTo60KB(file)

      setFormData((prev) => ({
        ...prev,
        vinImage: compressed,
      }))

      setPreview((prev) => ({
        ...prev,
        vin: URL.createObjectURL(compressed),
      }))
    } catch (err) {
      console.error("Compression error:", err)
    }
  }
  const handleOtherImages = async (e) => {
    const files = Array.from(e.target.files)

    try {
      const compressedFiles = await Promise.all(
        files.map((file) => compressTo60KB(file)),
      )

      setFormData((prev) => ({
        ...prev,
        otherImages: compressedFiles,
      }))

      const previews = compressedFiles.map((file) => URL.createObjectURL(file))

      setPreview((prev) => ({
        ...prev,
        others: previews,
      }))
    } catch (err) {
      console.error("Compression error:", err)
    }
  }

  const uploadSingleImage = async (file) => {
    if (!file) throw new Error("File missing")
    if (!storage) throw new Error("Storage not initialized")

    const fileName = `${Date.now()}-${file.name}`
    const imageRef = ref(storage, `dealerDropOffuploads/${fileName}`)

    await uploadBytes(imageRef, file)

    return await getDownloadURL(imageRef)
  }

  // TODO: Transfer data to firebase and also on Google Sheet
  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      // ✅ 1. Prepare final values (WITH REQUIRED FORMAT)
      const finalData = {
        dealer:
          formData.dealer === "other" ? formData.dealerOther : formData.dealer,

        submittedBy:
          formData.submittedBy === "other"
            ? formData.submittedOther
            : formData.submittedBy,

        make: formData.make,
        model: formData.model,
        year: formData.year,
        vin: formData.vin,

        service:
          selectedService === "other" ? otherSelectedService : selectedService,

        serviceStatus: formData.serviceStatus,
        serviceDuration: formData.serviceDuration,
      }

      // ✅ 2. Upload VIN Image
      let vinImageUrl = ""
      if (formData.vinImage) {
        vinImageUrl = await uploadSingleImage(formData.vinImage)
      }

      // ✅ 3. Upload Other Images
      let otherImageUrls = []
      if (formData.otherImages?.length) {
        otherImageUrls = await Promise.all(
          formData.otherImages.map((img) => uploadSingleImage(img)),
        )
      }

      // ✅ 4. Prepare payload
      const formPayload = new FormData()
      //entry.1423950138=dealer
      // &entry.1374308849=service
      // &entry.1929901040=addon
      // &entry.1724223801=make
      // &entry.1088213602=model
      // &entry.313981136=year
      // &entry.869947289=vinno
      // &entry.1534676975=vinimg
      // &entry.2100188133=otherimage
      // &entry.622351083=status
      // &entry.2113939777=duration
      // &entry.1277348119=submittiing
      // 🔹 Basic fields
      formPayload.append("entry.1423950138", finalData.dealer)
      // 🔹 Service
      formPayload.append("entry.1374308849", finalData.service)
      // 🔹 Addons (MULTI SELECT)
      serviceAddons.forEach((addon) => {
        if (addon !== "other") {
          formPayload.append("entry.1929901040", addon)
        }
      })
      // 🔹 Addon "Other"
      if (serviceAddons.includes("other")) {
        formPayload.append("entry.1929901040", serviceAddonOther)
      }
      formPayload.append("entry.1724223801", finalData.make)
      formPayload.append("entry.1088213602", finalData.model)
      formPayload.append("entry.313981136", finalData.year)
      formPayload.append("entry.869947289", finalData.vin)
      // 🔹 VIN Image
      formPayload.append("entry.1534676975", vinImageUrl)
      // 🔹 Other Images
      formPayload.append("entry.2100188133", otherImageUrls.join(", "))
      formPayload.append("entry.622351083", finalData.serviceStatus)
      formPayload.append("entry.2113939777", finalData.serviceDuration)

      // 🔹 Submitted By
      formPayload.append("entry.1277348119", finalData.submittedBy)

      // 🚀 5. Submit
      await fetch(
        "https://docs.google.com/forms/d/e/1FAIpQLSfk-Nsh1UQME4ilG0Qc23BsDJY0G86N1yFB8q4BpgDz1CrmEw/formResponse",
        {
          method: "POST",
          mode: "no-cors",
          body: formPayload,
        },
      )

      alert("Submitted successfully!")
      setSelectedOption("")
      setOtherText("")
      setPreview({ vin: "", others: [] })
      setFormData({
        dealer: "",
        dealerOther: "",
        service: "",
        serviceAddon: "",
        make: "",
        model: "",
        year: "",
        vin: "",
        submittedBy: "",
        submittedOther: "",
        vinImage: null,
        otherImages: [],
        serviceStatus: "",
        serviceDuration: "",
      })
    } catch (err) {
      console.error(err)
      alert("Submission failed")
    } finally {
      setLoading(false)
    }
  }

  const handleAddonChange = (value) => {
    setServiceAddons((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    )
  }
  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }
  // const handleVinImage = (e) => {
  //   const file = e.target.files[0]
  //   if (!file) return

  //   setFormData((prev) => ({ ...prev, vinImage: file }))
  //   setPreview((prev) => ({ ...prev, vin: URL.createObjectURL(file) }))
  // }
  // const handleOtherImages = (e) => {
  //   const files = Array.from(e.target.files)

  //   setFormData((prev) => ({ ...prev, otherImages: files }))

  //   const previews = files.map((file) => URL.createObjectURL(file))
  //   setPreview((prev) => ({ ...prev, others: previews }))
  // }

  return (
    <div className="flex items-center justify-center px-4 py-8">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md bg-white rounded-2xl shadow-lg p-6 space-y-6"
      >
        <h2 className="text-2xl font-bold text-center">
          Submit Dealers Details
        </h2>

        {/* Radio Options */}
        <div className="space-y-3">
          <p className="font-medium">
            Choose Dealer <span className="text-red-500">*</span>
          </p>

          {/* {dealer.map((opt) => (
            <label
              key={opt}
              className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer transition ${
                selectedOption === opt
                  ? "border-blue-500 bg-blue-50"
                  : "border-gray-200"
              }`}
            >
              <input
                type="radio"
                value={opt}
                checked={selectedOption === opt}
                onChange={(e) => setSelectedOption(e.target.value)}
                className="accent-blue-600"
              />
              <span className="capitalize">{opt}</span>
            </label>
          ))} */}

          <select
            value={formData.dealer}
            name="dealer"
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          >
            <option value="">Select Dealer</option>

            {dealer.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}

            <option value="other">Other</option>
          </select>

          {/* Other Input */}
          {formData.dealer === "other" && (
            <input
              type="text"
              placeholder="Enter Dealer name"
              value={formData.dealerOther}
              name="dealerOther"
              onChange={handleChange}
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          )}
        </div>

        {/* Service Options */}
        <div className="space-y-3">
          <p className="font-medium">
            Choose Service <span className="text-red-500">*</span>
          </p>

          {serviceList.map((opt) => (
            <label
              key={opt}
              className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer transition ${
                selectedService === opt
                  ? "border-blue-500 bg-blue-50"
                  : "border-gray-200"
              }`}
            >
              <input
                type="radio"
                name="service"
                value={opt}
                checked={selectedService === opt}
                onChange={(e) => setSelectedService(e.target.value)}
                className="accent-blue-600"
                required
              />
              <span className="capitalize">{opt}</span>
            </label>
          ))}

          {/* Other Input */}
          {selectedService === "Other" && (
            <input
              type="text"
              placeholder="Enter Service"
              value={otherSelectedService}
              onChange={(e) => setOtherSelectedService(e.target.value)}
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          )}
        </div>

        <div className="space-y-3">
          <p className="font-medium">Select Service Addons</p>

          {addonList.map((addon) => (
            <label
              key={addon}
              className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer ${
                serviceAddons.includes(addon)
                  ? "border-blue-500 bg-blue-50"
                  : "border-gray-200"
              }`}
            >
              <input
                type="checkbox"
                checked={serviceAddons.includes(addon)}
                onChange={() => handleAddonChange(addon)}
              />
              {addon}
            </label>
          ))}

          {/* Other Option */}
          <label className="flex items-center gap-3 p-3 border rounded-lg">
            <input
              type="checkbox"
              checked={serviceAddons.includes("other")}
              onChange={() => handleAddonChange("other")}
            />
            Other
          </label>

          {serviceAddons.includes("other") && (
            <input
              type="text"
              placeholder="Enter addon"
              value={serviceAddonOther}
              onChange={(e) => setServiceAddonOther(e.target.value)}
              className="w-full p-3 border rounded-lg"
              required
            />
          )}
        </div>

        {/* Text Input */}
        <div className="space-y-3">
          <p className="font-medium">
            Enter Make of Vehicle <span className="text-red-500">*</span>
          </p>
          {/* Make */}
          <input
            type="text"
            name="make"
            placeholder="Enter Make"
            value={formData.make}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg"
          />
        </div>

        {/* Text Input */}
        <div className="space-y-3">
          <p className="font-medium">
            Enter Model of Vehicle <span className="text-red-500">*</span>
          </p>
          {/* Model */}
          <input
            type="text"
            name="model"
            placeholder="Enter Model"
            value={formData.model}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg"
          />
        </div>

        {/* Text Input */}
        <div className="space-y-3">
          <p className="font-medium">
            Enter Year of Vehicle <span className="text-red-500">*</span>
          </p>
          {/* Year */}
          <input
            type="text"
            name="year"
            placeholder="Enter Year"
            value={formData.year}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg"
          />
        </div>

        {/* Text Input */}
        <div className="space-y-3">
          <p className="font-medium">
            Enter VIN Number of Vehicle <span className="text-red-500">*</span>
          </p>
          {/* VIN */}
          <input
            type="text"
            name="vin"
            placeholder="Enter VIN"
            value={formData.vin}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg"
          />
        </div>

        {/* Image Upload */}
        <div className="space-y-2">
          <label className="block font-medium">
            Upload VIN Number Image <span className="text-red-500">*</span>
          </label>

          <input
            type="file"
            accept="image/*"
            onChange={handleVinImage}
            className="w-full text-sm"
            required
          />

          {preview.vin ? (
            <img
              src={preview.vin}
              alt="preview"
              className="w-full h-40 object-contain rounded-lg border"
            />
          ) : null}
        </div>

        {/* Image Upload */}
        <div className="space-y-2">
          <label className="block font-medium">Upload Other Images</label>

          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleOtherImages}
            className="w-full text-sm"
          />

          <div className="grid grid-cols-3 gap-2">
            {preview.others.map((img, i) => (
              <img
                key={i}
                src={img}
                className="h-24 w-full object-cover rounded"
                alt="otherspreview"
              />
            ))}
          </div>
        </div>

        {/* Status */}
        <div className="space-y-2">
          <label className="font-medium">
            Service Status <span className="text-red-500">*</span>
          </label>

          <select
            name="serviceStatus"
            value={formData.serviceStatus}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
            required
          >
            <option value="">Select Status</option>

            {serviceStatus.map((person) => (
              <option key={person} value={person}>
                {person}
              </option>
            ))}
          </select>
        </div>

        {/* Service Time Duration */}
        <div className="space-y-3">
          <p className="font-medium">
            Enter Service Duration <span className="text-red-500">*</span>
          </p>
          {/* serviceDuration */}
          <input
            type="text"
            name="serviceDuration"
            placeholder="Enter Duration in Hrs"
            value={formData.serviceDuration}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg"
          />
        </div>

        {/* Submited Dropdown */}
        <div className="space-y-2">
          <label className="font-medium">
            By <span className="text-red-500">*</span>
          </label>

          <select
            name="submittedBy"
            value={formData.submittedBy}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
            required
          >
            <option value="">Select Person</option>

            {submittedPersons.map((person) => (
              <option key={person} value={person}>
                {person}
              </option>
            ))}

            <option value="other">Other</option>
          </select>

          {formData.submittedBy === "other" && (
            <input
              type="text"
              name="submittedOther"
              placeholder="Enter name"
              value={formData.submittedOther}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 mt-2"
            />
          )}
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition disabled:opacity-50"
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  )
}

export default DealerMobileScreen
